module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("nR7a3"))).then(() => parcelRequire('ljYL6'));